<template>
    <v-container class="pa-0">
        <v-card-text>
            <h3 class="mb-4 mt-3">Configuração de agendamento automático de expurgo em rascunho</h3>
            <v-form ref="formConfigDiasExpurgo">
                <v-row>
                    <v-col cols="10" md="8">
                        <m-text-field v-input-filter="[$filters.numeric]" v-model="tempo_rascunho" maxlength="3" label="Quantidade de dias de existência do rascunho para expurgo:" outlined placeholder="Informe a quantidade de dias" />
                    </v-col>
                </v-row>
            </v-form>
            <v-row class="d-flex justify-end">
                <v-col cols="2">
                    <v-btn class="transition" color="primary" rounded @click="salvarParametrizacaoExpurgo">
                        Salvar
                    </v-btn>
                </v-col>
            </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text>
            <h3 class="mb-4 mt-3">Configuração para recebimento do relatório de expurgo via e-mail</h3>
            <v-form ref="formEmailRelatorioExpurgo">
                <v-row>
                    <v-col cols="10" md="8">
                        <m-text-field
                                v-input-filter="[$filters.email]"
                                v-model="expurgo_email"
                                :rules="[$rules.email]"
                                maxlength="100"
                                label="Insira seu e-mail abaixo:"
                                outlined
                                placeholder="Ex: usuario@Rodobens.com.br"
                        />
                    </v-col>
                </v-row>
            </v-form>
            <v-row>
                <v-col cols="10" md="8">
                    <v-data-table mt="2" :headers="emailHeaders" :items="predefinedEmails" item-key="email" class="elevation-1">
                        <template v-slot:item.action="{ item, index }" class="text-center">
                            <v-icon small @click="removeEmail(item.id, index)" class="pl-2" color="black">mdi-delete</v-icon>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
            <v-row class="d-flex justify-end">
                <v-col cols="2">
                    <v-btn class="transition" color="primary" rounded @click="salvarExpurgoEmail">
                        Salvar
                    </v-btn>
                </v-col>
            </v-row>
        </v-card-text>
    </v-container>
</template>

<script>
  import { notification } from '@/plugins/helpers'
  import { AlertTypes } from '../../../plugins/alerts_types'

  export default {
    data () {
      return {
        tempo_rascunho: 0,
        expurgo_email: '',
        predefinedEmails: [],
        emailHeaders: [
          { text: 'E-mails configurados: ', value: 'email' },
          { text: 'Ações', value: 'action', sortable: false }
        ]
      }
    },
    async mounted () {
      this.loadIntervaloDias()
      this.loadExpurgoEmail()
    },
    methods: {
      confirmarExpurgo () {
        alert({
          text: 'Tem certeza que deseja realizar o expurgo?',
          buttons: {
            'Cancelar': () => {},
            'Confirmar': () => {
              this.expurgarPropostasManual()
            }
          }
        })
      },
      loadIntervaloDias () {
        this.$http.get('/painel/tempo_expurgo')
          .then(response => {
            this.tempo_rascunho = response.data.tempo_rascunho
          })
          .catch(() => {
            notification(AlertTypes.ERROR, 'Ocorreu um erro ao buscar a configuração de agendamento automático de expurgo.')
          })
      },
      salvarParametrizacaoExpurgo () {
        if (this.$refs.formConfigDiasExpurgo.validate()) {
          this.$http.put('/painel/agendar_expurgo', { tempo_rascunho: this.tempo_rascunho })
            .then(response => {
              notification(AlertTypes.SUCCESS, response.data.message)
            })
            .catch(() => {
              notification(AlertTypes.ERROR, 'Ocorreu um erro ao salvar o agendamento de expurgo.')
            })
        }
      },
      loadExpurgoEmail () {
        this.$http.get('/painel/expurgo_email')
          .then(response => {
            this.predefinedEmails = response.data.emails.map(email => ({ id: email.id, email: email.email }))
          })
          .catch(() => {
            notification(AlertTypes.ERROR, 'Ocorreu um erro ao buscar a configuração de expurgo.')
          })
      },
      setEmail (email) {
        this.expurgo_email = email
      },
      removeEmail (id, index) {
        this.$http.delete(`/painel/excluir_email/${id}`)
          .then(response => {
            const emailIndex = this.predefinedEmails.findIndex(item => item.id === id)
            if (emailIndex !== -1) {
              if (this.expurgo_email === this.predefinedEmails[emailIndex].email) {
                this.expurgo_email = ''
              }
              this.predefinedEmails.splice(emailIndex, 1)
              notification(AlertTypes.SUCCESS, 'E-mail excluído com sucesso.')
            }
          })
          .catch(error => {
            if (error.response && error.response.status === 500) {
              notification(AlertTypes.ERROR, 'Falha ao excluir o e-mail. Tente novamente mais tarde.')
            } else {
              notification(AlertTypes.ERROR, 'E-mail não encontrado.')
            }
          })
      },
      salvarExpurgoEmail () {
        if (this.$refs.formEmailRelatorioExpurgo.validate()) {
          const emailExists = this.predefinedEmails.some(item => item.email === this.expurgo_email)
          if (emailExists) {
            notification(AlertTypes.WARN, 'Este e-mail já está salvo na lista.')
            return
          }

          this.$http.post('/painel/salvar/email_expurgo', { email: this.expurgo_email })
            .then(response => {
              notification(AlertTypes.SUCCESS, response.data.message)
              this.loadExpurgoEmail()
              this.expurgo_email = ''
            })
            .catch(() => {
              notification(AlertTypes.ERROR, 'Erro ao salvar o e-mail de expurgo. Tente novamente mais tarde.')
            })
        }
      }
    }
  }
</script>
